import React, { useState } from 'react';
import { Slide } from '@mui/material';
import {
  KeyboardArrowRight,
  ReportGmailerrorred,
  CheckCircle,
} from '@mui/icons-material';
import { Clickable } from '@fashionnovateam/nova-ui-toolkit';
import PrinterConfigurationSelect from './PrinterConfigurationSelect/PrinterConfigurationSelect';
import styles from './PrinterConfiguration.module.css';
import { PrinterType } from './types';
import {
  BrowserPrintConfig,
  useBrowserPrint,
} from '../../../Lib/Hooks/browserPrint.hooks';

interface PrinterPopoverProps {
  containerRef: React.RefObject<HTMLDivElement | null>;
}

function PrinterPopover({ containerRef }: PrinterPopoverProps) {
  const { selectedDevices, setSelectedDevice } = useBrowserPrint();
  const [openPrinterSelect, setOpenPrinterSelect] =
    useState<PrinterType | null>(null);

  const handleBackClick = () => {
    setOpenPrinterSelect(null);
  };

  const handleContinueClick = (newConfig: BrowserPrintConfig) => {
    if (openPrinterSelect) {
      setSelectedDevice(openPrinterSelect, newConfig);
      setOpenPrinterSelect(null);
    }
  };

  const { unitLabel, hangTag, cartonLabel } = selectedDevices;
  const printersSet = !!(
    unitLabel.config &&
    hangTag.config &&
    cartonLabel.config
  );

  return (
    <div>
      <span className={styles.printerConfigTitle}>PRINTER CONFIGURATION</span>
      {printersSet ? (
        <div className={styles.printerConfigInfoContainer}>
          <CheckCircle className={styles.printerConfigSuccessIcon} />
          <p className={styles.printerConfigSuccessText}>{`You're all set!`}</p>
        </div>
      ) : (
        <div className={styles.printerConfigInfoContainer}>
          <ReportGmailerrorred className={styles.printerConfigWarningIcon} />
          <p className={styles.printerConfigWarningText}>
            Please configure your printers before you start printing.
          </p>
        </div>
      )}
      <div className="flex justify-between items-center mt-6">
        <span className={styles.printerConfigLabel}>Unit Label Printer</span>
        {unitLabel.config ? (
          <span className={styles.printerConfigBadgeSet}>
            {unitLabel.config.name || unitLabel.config.uid}
          </span>
        ) : (
          <span className={styles.printerConfigBadgeNotSet}>Not set</span>
        )}
        <Clickable onClick={() => setOpenPrinterSelect('unitLabel')}>
          <KeyboardArrowRight />
        </Clickable>
      </div>
      <div className="flex justify-between items-center mt-6">
        <span className={styles.printerConfigLabel}>Hangtag Printer</span>
        {hangTag.config ? (
          <span className={styles.printerConfigBadgeSet}>
            {hangTag.config.name || hangTag.config.uid}
          </span>
        ) : (
          <span className={styles.printerConfigBadgeNotSet}>Not set</span>
        )}
        <Clickable onClick={() => setOpenPrinterSelect('hangTag')}>
          <KeyboardArrowRight />
        </Clickable>
      </div>
      <div className="flex justify-between items-center mt-6">
        <span className={styles.printerConfigLabel}>Carton Label Printer</span>
        {cartonLabel.config ? (
          <span className={styles.printerConfigBadgeSet}>
            {cartonLabel.config.name || cartonLabel.config.uid}
          </span>
        ) : (
          <span className={styles.printerConfigBadgeNotSet}>Not set</span>
        )}
        <Clickable onClick={() => setOpenPrinterSelect('cartonLabel')}>
          <KeyboardArrowRight />
        </Clickable>
      </div>

      <Slide
        in={openPrinterSelect !== null}
        container={containerRef.current}
        direction="left"
      >
        <div className="absolute inset-0 bg-white p-6 shadow-lg rounded-lg">
          {openPrinterSelect ? (
            <PrinterConfigurationSelect
              printerType={openPrinterSelect}
              onBackClick={handleBackClick}
              onContinueClick={handleContinueClick}
            />
          ) : null}
        </div>
      </Slide>
    </div>
  );
}

export default PrinterPopover;
